import React from 'react';
import './no-reviews.scss';

const NoReviews = ({reviews, type}) => {
    // if we have reviews, return null - don't print
    if (reviews && reviews.size > 0) {
        return null;
    }

    const typeString = type ? i18n.t(`reviews.gigs._inner_gig.drop_${type}`) : i18n.t('reviews.general.reviews');

    return (
        <p className="no-reviews">
            {i18n.t('reviews.users.user_show.reviews_not_found', {type: typeString.toLowerCase()})}
        </p>
    );
};

export default NoReviews;



// WEBPACK FOOTER //
// ./src/reviews/no_reviews/NoReviews.js